// @flow
import createIcon from './utils/createIcon'

export default createIcon({
  iconName: 'calendar',
  icon: [
    448,
    512,
    null,
    null,
    'M400 64h-48V12a12 12 0 0 0-12-12h-8a12 12 0 0 0-12 12v52H128V12a12 12 0 0 0-12-12h-8a12 12 0 0 0-12 12v52H48a48 48 0 0 0-48 48v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V112a48 48 0 0 0-48-48zM48 96h352a16 16 0 0 1 16 16v48H32v-48a16 16 0 0 1 16-16zm352 384H48a16 16 0 0 1-16-16V192h384v272a16 16 0 0 1-16 16zM148 320h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12v40a12 12 0 0 1-12 12zm96 0h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12v40a12 12 0 0 1-12 12zm96 0h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12v40a12 12 0 0 1-12 12zm-96 96h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12v40a12 12 0 0 1-12 12zm-96 0h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12v40a12 12 0 0 1-12 12zm192 0h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12v40a12 12 0 0 1-12 12z',
  ],
})
